/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './vaccination-schedule.reducer';

export const VaccinationScheduleDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const vaccinationScheduleEntity = useAppSelector(state => state.vaccinationSchedule.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="vaccinationScheduleDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.vaccinationSchedule.detail.title">VaccinationSchedule</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.vaccinationSchedule.id">Id</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.vaccinationSchedule.active">Active</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="activeFlag">
              <Translate contentKey="tinyMedicRestApp.vaccinationSchedule.activeFlag">Active Flag</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleEntity.activeFlag ? 'true' : 'false'}</dd>
          <dt>
            <span id="ageGroup">
              <Translate contentKey="tinyMedicRestApp.vaccinationSchedule.ageGroup">Age Group</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleEntity.ageGroup}</dd>
          <dt>
            <span id="country">
              <Translate contentKey="tinyMedicRestApp.vaccinationSchedule.country">Country</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleEntity.country}</dd>
          <dt>
            <span id="scheduleDesc">
              <Translate contentKey="tinyMedicRestApp.vaccinationSchedule.scheduleDesc">Schedule Desc</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleEntity.scheduleDesc}</dd>
          <dt>
            <span id="scheduleName">
              <Translate contentKey="tinyMedicRestApp.vaccinationSchedule.scheduleName">Schedule Name</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleEntity.scheduleName}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.vaccinationSchedule.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.vaccinationSchedule.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.vaccinationSchedule.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.vaccinationSchedule.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/vaccination-schedule" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/vaccination-schedule/${vaccinationScheduleEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default VaccinationScheduleDetail;
